<template>
  <div class="main-container">
    <router-view></router-view>
    <!-- Navbar section -->
    <HeaderSoftware/>
    <div class="container-policy">
      <div style="margin-left: 20%;margin-bottom:10%">
        <h1>YourSynchronicity Privacy Policy</h1>
      </div>
      <h1>About YourSynchronicity</h1>
      <p>
        YourSynchronicity is a web services platform that automates certain networking tasks on
        LinkedIn.
        Our service imitates human behavior and makes it easy for its users to network efficiently.
        <br><br>
        This privacy notice explains how we collect, share and protect business information.
      </p>
      <h2>Data We Collect</h2>
      <h3>Registration</h3>
      <p>
        To create an account you need to provide your LinkedIn login credentials.
      </p>
      <h2>Service Use</h2>
      <p>
        We log usage data when you visit or otherwise use our Services, including our app and
        platform technology such as when you search, set up campaigns, view or click. We use
        log-ins, cookies, device information and internet protocol (“IP”) addresses to identify you
        and log your use.

      </p>
      <h2>Data Retention</h2>
      <p>
        We retain your personal data while your account is in existence or as needed to provide you
        Services. This includes data you have provided to us and data generated or inferred from
        your use of our Services. We will retain your information and keep your data until you
        decide to close your account. Once you close your account, we delete all your data from our
        systems. In some cases, we choose to retain certain information like name and email address
        in order to remarket to you. You will however always have the option to opt-out from our
        marketing communications.
      </p>
      <h2>Security</h2>
      <p>
        We implement security safeguards designed to protect your data, such as HTTPS. We regularly
        monitor our systems for possible vulnerabilities and attacks. Our applications pseudonymize
        data to ensure the privacy of data subjects. Any attributes that don’t need to remain in its
        original form is truncated to remove any possibility to be linked back to a specific data
        subject. However, we cannot warrant the security of any information that you send us. There
        is no guarantee that data may not be accessed, disclosed, altered, or destroyed by breach of
        any of our physical, technical, or managerial safeguards.
      </p>
      <h2>Marketing & Data Sharing</h2>
      <p>
        We do not share your personal data with any third parties for their direct marketing
        purpose.
      </p>
      <h2>Contact Information</h2>
      <p>If you have questions or complaints regarding this Policy, please first contact us at
        privacy@yoursynchronicity.com
      </p>

    </div>
    <FooterMain/>

  </div>
</template>

<script>

    import ThreeStepProcessWrap from "../../components/AeroLandingPage/ThreeStepProcessWrap";
    import HeaderSoftware from "../../components/AeroLandingPage/HeaderSoftware";
    import HeroSoftware from "../../components/AeroLandingPage/HeroSoftware";
    import BrandLogoCarousel from "../../components/AeroLandingPage/BrandLogoCarousel";
    import FeatureList from "../../components/AeroLandingPage/FeatureList";
    import TabTwo from "../../components/AeroLandingPage/TabTwo";
    import ProgressBar from "../../components/AeroLandingPage/ProgressBar";
    import PricingOne from "../../components/AeroLandingPage/PricingOne";
    import CurveShape from "../../components/AeroLandingPage/CurveShape";
    import CtaThree from "../../components/AeroLandingPage/CtaThree";
    import FunFactOne from "../../components/AeroLandingPage/FunFactOne";
    import Accordion from "../../components/AeroLandingPage/Accordion";
    import Newsletter from "../../components/AeroLandingPage/Newsletter";
    import FooterMain from "../../components/AeroLandingPage/FooterMain";
    import OffcanvasSearchBox from "../../components/AeroLandingPage/OffcanvasSearchBox";
    import SassFeature from "../../components/AeroLandingPage/SassFeature";

    // localStorage.clear();
    export default {
        name: "terms",
        components: {
            HeaderSoftware,
            HeroSoftware,
            BrandLogoCarousel,
            SassFeature,
            FeatureList,
            TabTwo,
            ProgressBar,
            PricingOne,
            CurveShape,
            CtaThree,
            FunFactOne,
            Accordion,
            Newsletter,
            FooterMain,
            OffcanvasSearchBox,
            ThreeStepProcessWrap,
        },
        created() {
        }

    };
</script>
<style scoped>
  .container-policy {
    margin-top: 10%;
    margin-left: 25%;
    max-width: 50%;
  }
</style>
